/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Page_TitleInputs */

const en_error_page_title = /** @type {(inputs: Error_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This page didn't load`)
};

const es_error_page_title = /** @type {(inputs: Error_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta página no cargó`)
};

const de_error_page_title = /** @type {(inputs: Error_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Seite wurde nicht geladen`)
};

const zh_error_page_title = /** @type {(inputs: Error_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`该页面未加载`)
};

const ar_error_page_title = /** @type {(inputs: Error_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعذّر تحميل هذه الصفحة`)
};

const fr_error_page_title = /** @type {(inputs: Error_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette page ne s'est pas chargée`)
};

const vi_error_page_title = /** @type {(inputs: Error_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trang này không tải được`)
};

const sw_error_page_title = /** @type {(inputs: Error_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukurasa huu haukupakiwa`)
};

const th_error_page_title = /** @type {(inputs: Error_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`หน้านี้ไม่ได้โหลด`)
};

const bs_error_page_title = /** @type {(inputs: Error_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ova stranica se nije učitala`)
};

const ja_error_page_title = /** @type {(inputs: Error_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このページは読みませんでした`)
};

const ko_error_page_title = /** @type {(inputs: Error_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 페이지는 로드하지 않았습니다.`)
};

const pt_error_page_title = /** @type {(inputs: Error_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta página não carregou`)
};

const it_error_page_title = /** @type {(inputs: Error_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questa pagina non ha caricato`)
};

const sv_error_page_title = /** @type {(inputs: Error_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denna sida laddade inte`)
};

const nl_error_page_title = /** @type {(inputs: Error_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze pagina heeft niet geladen`)
};

const da_error_page_title = /** @type {(inputs: Error_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denne side har ikke indlæse`)
};

const nb_error_page_title = /** @type {(inputs: Error_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denne siden lastet ikke`)
};

const fi_error_page_title = /** @type {(inputs: Error_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tämä sivu ei ladannut`)
};

const pl_error_page_title = /** @type {(inputs: Error_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta strona nie załadowała`)
};

const ru_error_page_title = /** @type {(inputs: Error_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Эта страница не загружается`)
};

const tr_error_page_title = /** @type {(inputs: Error_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu sayfa yüklemedi`)
};

const hi_error_page_title = /** @type {(inputs: Error_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह पेज लोड नहीं हुआ`)
};

const id_error_page_title = /** @type {(inputs: Error_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halaman ini tidak dimuat`)
};

const ms_error_page_title = /** @type {(inputs: Error_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halaman ini gagal dimuatkan`)
};

const cs_error_page_title = /** @type {(inputs: Error_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tahle stránka se nenahrála.`)
};

const el_error_page_title = /** @type {(inputs: Error_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Αυτή η σελίδα δεν φορτώθηκε.`)
};

const he_error_page_title = /** @type {(inputs: Error_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`דף זה לא נטען`)
};

const af_error_page_title = /** @type {(inputs: Error_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hierdie bladsy het nie gelaai nie`)
};

const hu_error_page_title = /** @type {(inputs: Error_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ez az oldal nem töltődött.`)
};

/**
* | output |
* | --- |
* | "This page didn't load" |
*
* @param {Error_Page_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const error_page_title = /** @type {((inputs?: Error_Page_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Page_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_error_page_title(inputs)
	if (locale === "de") return de_error_page_title(inputs)
	if (locale === "zh") return zh_error_page_title(inputs)
	if (locale === "ar") return ar_error_page_title(inputs)
	if (locale === "fr") return fr_error_page_title(inputs)
	if (locale === "vi") return vi_error_page_title(inputs)
	if (locale === "sw") return sw_error_page_title(inputs)
	if (locale === "th") return th_error_page_title(inputs)
	if (locale === "bs") return bs_error_page_title(inputs)
	if (locale === "ja") return ja_error_page_title(inputs)
	if (locale === "ko") return ko_error_page_title(inputs)
	if (locale === "pt") return pt_error_page_title(inputs)
	if (locale === "it") return it_error_page_title(inputs)
	if (locale === "sv") return sv_error_page_title(inputs)
	if (locale === "nl") return nl_error_page_title(inputs)
	if (locale === "da") return da_error_page_title(inputs)
	if (locale === "nb") return nb_error_page_title(inputs)
	if (locale === "fi") return fi_error_page_title(inputs)
	if (locale === "pl") return pl_error_page_title(inputs)
	if (locale === "ru") return ru_error_page_title(inputs)
	if (locale === "tr") return tr_error_page_title(inputs)
	if (locale === "hi") return hi_error_page_title(inputs)
	if (locale === "id") return id_error_page_title(inputs)
	if (locale === "ms") return ms_error_page_title(inputs)
	if (locale === "cs") return cs_error_page_title(inputs)
	if (locale === "el") return el_error_page_title(inputs)
	if (locale === "he") return he_error_page_title(inputs)
	if (locale === "af") return af_error_page_title(inputs)
	if (locale === "hu") return hu_error_page_title(inputs)
	return en_error_page_title(inputs)
});